import { createContext } from 'react';

import type { CompanyFeatureFlags, UserFeatureFlags } from '../types';

export interface FeatureFlagsCtx {
  userFeatureFlags: Readonly<UserFeatureFlags> | null;
  companyFeatureFlags: Readonly<CompanyFeatureFlags> | null;
  setUserFeatureFlags: (f: UserFeatureFlags | null) => void;
  setCompanyFeatureFlags: (f: CompanyFeatureFlags | null) => void;
}

export const FeatureFlagsContext = createContext<FeatureFlagsCtx>({
  userFeatureFlags: null,
  companyFeatureFlags: null,
  setUserFeatureFlags: () => {},
  setCompanyFeatureFlags: () => {},
});
